import React from "react";
import { Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SafariPackageCardSkeleton = ({ count }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
         <Col
         className="mb-xl-4 mb-md-3 mb-4 padding_righ"
         key={ index}
       >
        <Skeleton height={232} width="100%"  className="img-dummy"/>
        <div className="sharesafri-card-dummy tourpackage">    
         
            
         

          <div className="">
            {/* Title */}
            <div className="titleDate">
              <h6 className="pt-1">
                <Skeleton width="80%" height={20}/>
              </h6>

              {/* Organizer Tour Icons */}
              <div className="orgnizer_tour d-flex justify-content-between ">
                {[...Array(3)].map((_, iconIndex) => (
                  <div className="icons_restro text-center" key={iconIndex}>
                    <Skeleton height={20} width={20} className="mb-1" />
                    <Skeleton width={60} height={10} />
                  </div>
                ))}
              </div>
            </div>

            {/* Footer */}
            <div className="footer_card row pb-2 px-2 align-items-center">
              <div className="col-6 col-lg-6 col-md-7">
                <div className="safaritourlogo">
                  <Skeleton height={60} width="80%" style={{borderRadius:"8px"}}/>
                </div>
              </div>
              <div className="col-6 col-md-5 col-lg-6 ">
                <div className="safari text-center">
                  <Skeleton width={80} height={20} className="mb-2" />
                  <Skeleton width={120} height={30} style={{borderRadius:"8px"}} />
                </div>
              </div>
            </div>
          </div>
        </div>
        </Col>
      ))}
    </>
  );
};

export default SafariPackageCardSkeleton;
